import React from 'react';

import { isUpdatedInPlace, RowFlag } from '~support-at-home/lib/bulkUpdate';
import { BulkUpdateRow } from '~support-at-home/lib/contributionSelection';

interface ComponentProps {
  row: BulkUpdateRow;
  // The new rate, or null until a valid one is typed.
  proportion: number | null;
  // The effective date, or null until a valid one is entered.
  validDate: string | null;
  // The client-side pre-check for this row, if it is over its category maximum or ends before the date.
  flag?: RowFlag;
  // The server's reason this row was rejected, if it was.
  serverReason?: string;
}

// The preview's Rate cell: "15% → 20%" (or "15% → –" before a rate is typed), then one short note that
// gives way first when the column is narrow: the server's reason, "max 50%" / "ends 31/Oct/2026", or a
// muted "in place".
// Called as a plain function from forms/client-contributions/bulkPreview.ts.
const BulkPreviewRateCell = ({ row, proportion, validDate, flag, serverReason }: ComponentProps) => {
  const old = `${row.contrib_proportion ?? ''}%`;
  const next = proportion !== null ? `${proportion}%` : '–';

  let note: React.ReactNode = null;
  if (serverReason) {
    note = (
      <span className="bulk-update-note text-danger" title={serverReason}>
        {serverReason}
      </span>
    );
  } else if (flag) {
    note = (
      <span className="bulk-update-note text-danger" title={flag.reason}>
        {flag.short}
      </span>
    );
  } else if (validDate !== null && isUpdatedInPlace(row, validDate)) {
    note = (
      <span className="bulk-update-note text-muted" title="Updated in place">
        in place
      </span>
    );
  }

  return (
    <div className="bulk-update-rate">
      <span className="text-nowrap">{`${old} → ${next}`}</span>
      {note}
    </div>
  );
};

export default BulkPreviewRateCell;
